import { Component, Prop } from 'vue-property-decorator';

import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { ProgramaIntegrado } from '@/shared/model/snp/programa-integrado.model';
import { required } from 'vuelidate/lib/validators';
import ProgramaIntegradoConRegistro from '@/entities/snp/solicitud/posgrado/programaIntegradoCon/programa-integrado-con-registro.vue';
import ProgramaIntegradoConListado from '@/entities/snp/solicitud/posgrado/programaIntegradoCon/programa-integrado-con-listado.vue';
import { Solucion } from '@/shared/model/solucion.model';

const validations = function () {
  return {
    programaIntegrado: {
      fechaInicio: { required },
    },
  };
};
@Component({
  validations,
  components: {
    'programa-integrado-con-registro': ProgramaIntegradoConRegistro,
    'programa-integrado-con-listado': ProgramaIntegradoConListado,
  },
})
export default class ProgramaIntegradoConComponent extends ApeironComponent {
  @Prop({ required: true })
  public solucion: Solucion;

  @Prop({ required: true })
  public solicitud: Solicitud;

  public esVisibleRegistro = false;
  public esVisibleListado = true;

  public agregarProgramaIntegradoConATabla(): void {
    this.esVisibleRegistro = false;
    this.esVisibleListado = true;
  }

  public eliminarProgramaIntegradoDeTabla(): void {
    this.esVisibleRegistro = true;
    this.esVisibleListado = false;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }
}
